import React, { Component } from 'react';
import LazyLoad from 'react-lazyload';
import { Col } from 'react-flexbox-grid';
import { Heading, Link, Image, Paragraph, IconSVG } from 'components';
import {
  getArticleSlug,
  estimateReadTime,
  getCloudinaryUrl,
} from 'config/helpers';
import './SinglePostTile.scss';

class SinglePostTile extends Component {
  handleCategoryClick = (event, category) => {
    event.stopPropagation();
    event.preventDefault();
    this.props.toggleFilter(category);
  };

  render() {
    const { post, contributors, theme } = this.props;
    const { frontmatter } = post.node;
    const { title, cover, settings, contributor, content } = frontmatter;
    const contributorData = contributors.filter(
      edge => edge.node.frontmatter.title === contributor,
    );

    const articlePureContent = content
      .reduce((a, b) => a.body || a + b.body, '')
      .replace(/[^a-zA-Z ]/g, ' ');

    const readTime = estimateReadTime(articlePureContent);

    return (
      <Col sm={12} md={6} lg={4}>
        <Link to={getArticleSlug(post)}>
          <div
            className={`single-post-tile ${
              theme ? `single-post-tile--${theme}` : ''
            }`}
          >
            <div className={'single-post-tile__top'}>
              <LazyLoad once offset={200} height={'100%'}>
                <Image
                  src={getCloudinaryUrl(cover, 'f_auto,q_auto:best,h_300')}
                  alt={title}
                  placeholder
                />
              </LazyLoad>
            </div>
            <div className={'single-post-tile__bottom'}>
              <div
                className={`single-post-tile__info ${
                  theme === 'black' ? 'single-post-tile__info--black' : ''
                }`}
              >
                <button
                  onClick={e => this.handleCategoryClick(e, settings.category)}
                >
                  <Paragraph
                    size={'small'}
                    color={theme === 'black' ? 'black' : 'red'}
                    additionalClass={'single-post-tile__category text--bold'}
                  >
                    {settings.category}
                  </Paragraph>
                </button>
                <Paragraph
                  size={'small'}
                  additionalClass={'single-post-tile__time'}
                >
                  {readTime} min read
                </Paragraph>
                <IconSVG name={'time'} color={'black'} />
              </div>
              <div className={'single-post-tile__content'}>
                <Heading type={3} size={'medium'}>
                  {title}
                </Heading>
                {contributorData.length > 0 && (
                  <div className={'single-post-tile__contributor'}>
                    <LazyLoad once offset={200}>
                      <Image
                        src={getCloudinaryUrl(
                          contributorData[0].node.frontmatter.photo,
                          'f_auto,q_auto,w_100',
                        )}
                        alt={`${
                          contributorData[0].node.frontmatter.title
                        } avatar`}
                        placeholder
                      />
                    </LazyLoad>
                    <Paragraph size={'small'}>
                      {contributorData[0].node.frontmatter.title}
                      <br />
                      <span className={'text--light'}>
                        {contributorData[0].node.frontmatter.job}
                      </span>
                    </Paragraph>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Link>
      </Col>
    );
  }
}

SinglePostTile.defaultProps = {
  theme: 'white',
};

export default SinglePostTile;
